export default {
  computed: {
    isHookTypeInbox() {
      return this.integration.hook_type === 'inbox';
    },
    isHookTypeSchoolAccount() {
      return this.integration.hook_type === 'school_account';
    },
    hasConnectedHooks() {
      return !!this.integration.hooks.length;
    },
  },
};
